<template>
    <div>
        <el-drawer title="" :show-close="showClose" size="330" :visible.sync="drawer" :with-header="withHeader" :direction="direction" :before-close="limpiarPerfil">
            <section class="sidebar" v-if="pro.nombre">
                <el-image
                    style="width: 330px; height: 330px"
                    :src="pro.foto"
                    fit="cover">
                    <div slot="placeholder" class="image-slot">
                        Cargando <span class="dot">...</span>
                    </div>
                </el-image>
                <div class="text-black vinotinto px-3 py-4 mb-0">
                    <el-row class="d-flex align-items-end mb-4">
                        <el-col :span="18" class="ivy-thin s-24">
                            {{ pro.nombre }}
                        </el-col>
                        <el-col :span="6" class="text-right text-yellow s-20 comfy r-10 el-col el-col-6 text-center mb-1">
                            <i class="el-icon-star-on s-22"></i> {{ pro.calificacion_promedio }}
                        </el-col>
                    </el-row>
                    <el-divider></el-divider>
                    <el-row>
                        <el-col :span="12">
                            <el-rate
                                v-model="cinco"
                                disabled
                                show-score
                                text-color="#ff9900"
                                score-template="">
                            </el-rate>
                        </el-col>
                        <el-col :span="12">
                            {{ pro.calificacion_promedio_cinco }}
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-rate
                                v-model="cuatro"
                                disabled
                                show-score
                                text-color="#ff9900"
                                score-template="">
                            </el-rate>
                        </el-col>
                        <el-col :span="12">
                            {{ pro.calificacion_promedio_cuatro }}
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-rate
                                v-model="tres"
                                disabled
                                show-score
                                text-color="#ff9900"
                                score-template="">
                            </el-rate>
                        </el-col>
                        <el-col :span="12">
                            {{ pro.calificacion_promedio_tres }}
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-rate
                                v-model="dos"
                                disabled
                                show-score
                                text-color="#ff9900"
                                score-template="">
                            </el-rate>
                        </el-col>
                        <el-col :span="12">
                            {{ pro.calificacion_promedio_dos }}
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-rate
                                v-model="uno"
                                disabled
                                show-score
                                text-color="#ff9900"
                                score-template="">
                            </el-rate>
                        </el-col>
                        <el-col :span="12">
                            {{ pro.calificacion_promedio_uno }}
                        </el-col>
                    </el-row>
                    <el-divider></el-divider>
                    <el-row class="d-flex align-items-center">
                        <el-col :span="5">
                            <i class="el-icon-star-off s-28"></i>
                        </el-col>
                        <el-col :span="19">
                            <span class="demonstration d-block s-10 font-weight-bold">NÚMERO DE CALIFICACIONES</span>
                            <span class="s-16">{{ pro.calificacion_cantidad }}</span>
                        </el-col>
                    </el-row>
                    <el-divider></el-divider>
                    <el-row class="d-flex align-items-center">
                        <el-col :span="5">
                            <i class="el-icon-date s-28"></i>
                        </el-col>
                        <el-col :span="19">
                            <span class="demonstration d-block s-10 font-weight-bold">RESERVAS FINALIZADAS EN COMFY</span>
                            <span class="s-16">{{ pro.servicios_finalizados }}</span>
                        </el-col>
                    </el-row>
                    <el-divider></el-divider>
                    <el-row class="d-flex align-items-center">
                        <el-col :span="5">
                            <i class="el-icon-medal s-28"></i>
                        </el-col>
                        <el-col :span="19">
                            <span class="demonstration d-block s-10 font-weight-bold">CON COMFY HACE</span>
                            <span class="s-16">{{ pro.pro_registro }}</span>
                        </el-col>
                    </el-row>
                    <el-divider v-if="pro.pro_titulos"></el-divider>
                    <el-row v-if="pro.pro_titulos" class="d-flex align-items-center">
                        <el-col :span="5">
                            <i class="el-icon-trophy s-28"></i>
                        </el-col>
                        <el-col :span="19">
                            <span class="demonstration d-block s-10 font-weight-bold">ESPECIALIDAD</span>
                            <span class="s-16">{{ pro.pro_titulos }}</span>
                        </el-col>
                    </el-row>
                    <div v-show="pro.seguro">
                        <el-divider></el-divider>
                        <el-row class="d-flex align-items-center">
                            <el-col :span="5">
                                <i class="el-icon-medal-1 s-28"></i>
                            </el-col>
                            <el-col :span="19">
                                <span class="s-16">Totalmente asegurada y certificada</span>
                            </el-col>
                        </el-row>
                    </div>
                    <div v-show="pro.bio">
                        <el-divider></el-divider>
                        <el-row class="d-flex align-items-center">
                            <el-col :span="5">
                                <i class="el-icon-user s-28"></i>
                            </el-col>
                            <el-col :span="19">
                                <span class="demonstration d-block s-10 font-weight-bold">BIO</span>
                                <p class="s-14" style="max-width: 290px;">{{ pro.bio }}</p>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </section>
        </el-drawer>
    </div>
</template>

<script>
    export default {
        props: [
            'enviarPerfil'
        ],
        data() {
            return {
                perfil: null,
                pro: [],
                activeName: 'first',
                drawer: false,
                direction: 'rtl',
                withHeader: true,
                showClose: true,
                cinco: 5,
                cuatro: 4,
                tres: 3,
                dos: 2,
                uno: 1,
            }
        },
        computed: {

        },
        watch: {

        },
        methods: {
            consultarPro(id){
                this.perfil = id;
                this.drawer = true;
                var url = `/cliente/pro/consultar/${id}`
                axios.get(url)
                .then(response => {
                    console.log(response);
                    this.pro = response.data.pro;
                })
                .catch(e => {
                    const { error } = e.response.data;
                    if (error) {
                        this.pro = {
                            estado: 0,
                            mensaje: 'No hay datos de PRO'
                        };
                    }
                });
            },
            limpiarPerfil(done){
                this.pro = [];
                this.calificaciones = [];
                this.calificaciones_error = null;
                this.perfil = null;
                done();
            }
        },
        mounted() {
            // console.log('--- perfil component mounted ---')
            EventBus.$on('consultarPerfil', data => {
                this.consultarPro(data);
            });
        }
    }
</script>

<style>
.el-tabs__active-bar {
    background-color: #e0d6af;
}
.el-tabs__item.is-active {
    color: #18333e;
}
.el-tabs__item:hover {
    color: #45c7ed;
}
.el-divider--horizontal {
    margin: 14px 0;
}
.el-drawer__header {
    color: #ffffff;
    display: -ms-flexbox;
    display: inherit;
    margin-bottom: 0px;
    padding: 0px 0px;
    z-index: 9;
}
.el-drawer__close-btn {
    background-color: #18333e;
}
.el-drawer__body {
    top: -33px;
    position: relative;
}
</style>